<dib-dialog-title>
  <div class="flex items-center space-x-2">
    <span>Change Password</span>
    <span *ngIf="!isCurrentUser" class="text-sm font-normal text-gray-500">({{ user.fullName }})</span>
  </div>
</dib-dialog-title>
<mat-dialog-content class="mt-4 mb-6">
  <form [formGroup]="form" class="grid grid-cols-1">
    <mat-form-field class="mb-1">
      <mat-label>New Password</mat-label>
      <input matInput type="password" name="password" formControlName="password" autocomplete="off" />
      <mat-hint>Password must be minimum 6 characters long</mat-hint>
    </mat-form-field>
    <mat-form-field>
      <mat-label>Confirm New Password</mat-label>
      <input matInput type="password" name="confirmPassword" formControlName="confirmPassword" autocomplete="off" />
    </mat-form-field>
  </form>
</mat-dialog-content>
<mat-dialog-actions class="mb-1 justify-end">
  <button mat-button [mat-dialog-close]="false">Cancel</button>
  <button
    mat-button
    color="primary"
    [ngClass]="form.invalid ? 'mat-flat-button' : 'mat-stroked-button'"
    [mat-dialog-close]="close()"
    [disabled]="form.invalid"
  >
    Change Password
  </button>
</mat-dialog-actions>
